import { IApplicationState } from '../../types/redux';

export const selectChatState = (state: IApplicationState) => {
  return state.chatModal;
};
